import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { first } from 'rxjs';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import * as $ from 'jquery';
import { TimeScale } from 'chart.js';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-mentor-index',
  templateUrl: './mentor-index.component.html',
  styleUrls: ['./mentor-index.component.scss']
})
export class MentorIndexComponent implements OnInit {

district_list: any[] = this.ApiService.all_districts;
  users: any = JSON.parse(localStorage.getItem('login_user_details'));
  district: any;
  constituency: string = '';
  OBConstituency: string;
  user_constituency: any = this.ApiService.all_constituency['Chennai North'];
  assigned_to: any;
  zones: any = this.ApiService.zones;
  //user_name: any = this.ApiService.user_details.firstname;
  //user_id: any = this.ApiService.user_details.id;
  activity_type: any;
  activity_date: any;
  activity_time: any;
  activity: any;
  description: any;
  status: any;
  others: any;
  customers: any = [];
  summary_activity: any = [];
    MeetingOptions:any;
  participantsptions:any;
  // districts:any=['Salem','Karur','Namakkal','Trichy'];
  createmeetingform !:FormGroup;
  constituencies!:any;
  meeting_name: any;
  meeting_time: any;
  meeting_date: any;
  participants: any;
  meeting_type: any;
  meeting_location: any;
  spinner: boolean;
  hidden:boolean=true;
  dropdownList : string[]= [];
  dropdownSettings: IDropdownSettings = {};
  add = [];
  name: any;
  last_name: any;
  DOB: any;
  education: any;
  email: any;
  number: any;
  parent_number: any;
  branch: any;
  area: any;
  courses: any;
  grade: any;
  college_name: any;
  subject: any;
  uploadFiles: any = '';
  list_courses: any = [];
  password: any = '';
  confirm_password: any = '';
  password_wrong: any = false;
  

  
  
 
  selectedItems = [];
  
  dropDownForm: FormGroup;
  tableshow: boolean=false;
  editmeetingform !:FormGroup;
  Mentor_id: any;
  Mentor_zone: any;


  getChangeAssignedTo(assigned_to: any) {
    console.log(assigned_to)
    if (assigned_to === 'District') {
      $('#Check1').css('display','flex')
    } else {
       $('#Check1').css('display','none')
    }
      if (assigned_to === 'Zone') {
      $('#zones').css('display','block')
    } else {
       $('#zones').css('display','none')
    }
  }


  getChangeToConstituey(value: any) {
    console.log(value);
    this.user_constituency = this.ApiService.all_constituency[value];
      this.ApiService.datablelogin(value).subscribe((data: any) => {
      let obj = data;
        this.customers = obj.data;
  
      //console.log(obj.data.length);
    });
  }

  handleActivityTypeChange(value: any) {
    console.log(value);
    if (value === 'Others') {
      $('#others').css('display', 'block');
    } else {
        $('#others').css('display', 'none');
    }
  }



  handleDeleteClick(id: any) {
    
    $(`#adding_${id}`).remove();
  }

   onItemSelect(item: any) {
    console.log('onItemSelect', item);
  }
  onItemDeSelect(item: any) {
      console.log('onItemDeSelect', item);
  }
  onSelectAll(items: any) {
      console.log('onSelectAll', items);
  }
  onUnSelectAll() {
      console.log('onUnSelectAll fires');
  }

  

  constructor(private fb: FormBuilder,private ApiService: ApiServiceService,private router:Router,private spinnerService: NgxSpinnerService,
    public datepipe:DatePipe, private elementRef: ElementRef, private renderer: Renderer2) {
    this.createmeetingform= this.fb.group({
      name: ['',[Validators.required]],
      first_name: ['',[Validators.required]],
      last_name:['',Validators.required,],
      education:['',Validators.required],
      branch:['',Validators.required],
      constituency:['',Validators.required],
      email:['',Validators.required],
      number:['',Validators.required],
      area:['',Validators.required],
      courses:['',Validators.required],
      district:['',Validators.required],
      status: ['', Validators.required],
      image: ['', Validators.required],
        password: ['', Validators.required],
        confirm_password: ['', Validators.required,],
      }, { validator: this.passwordMatchValidator });
    
    this.editformInitialize('false');

  }


  dtOptions: DataTables.Settings = {};
  date:any;
  ngOnInit(): void{
    this.handleBackButtonForModal();

   // console.log(this.users,this.users.firstname, "sndknsdkjn");
  this.date=new Date();
// document.write(today);
    this.customers=[];
    this.showSpinner();
    // this.ApiService.getMentorsList().subscribe((data: any) => {
    //   console.log(data,"s,mfdnsd");

    // //   const datas = data.map((item: any) => {
    // //     let action = item.status === 'Active' ? 'Approve' : item.status === 'Inactive' ? 'Reject' : 'Status';
    // //     return {
    // //         ...item,
    // //         action: action
    // //     };
    // // });
    // this.customers=data;
    // // this.customers.status=(this.selectedAction==='Active') ? 'Approve' : (this.selectedAction==='Active')'Reject' ; 
    // console.log(' data.status: ',  this.customers.status);
    // // console.log('datas: ', datas);
    //   // this.selectedAction = (data[0].status === 'Active') ? 'Approve' : 'Reject';

    //   // console.log('data.status: ', data[0].status);
    //   // this.customers=data;
    //   this.tableshow=true;
    //   //console.log(this.customers.length);
    //   //console.log(obj.data.length);
    //   console.log(this.customers,"dsdksbk");
    //   ;
    // })

    this.ApiService.getMentorsList().subscribe((data: any) => {
      console.log(data,"s,mfdnsd");
     
      this.customers=data;
      this.tableshow=true;
      //console.log(this.customers.length);
      //console.log(obj.data.length);
      console.log(this.customers,"dsdksbk");
      ;
    })
    
    this.ApiService.getCourses().subscribe((data: any) => {
      console.log('data', data);
      this.dropdownList = data.map(res => res.course_name);
    })

    // this.getdata();
    // this.ApiService.viewtableOB();
    // this.ApiService.viewtableDA();
    // this.ApiService.viewtableSA();
    // this.ApiService.viewtableOBapprove();
    // this.ApiService.viewtablemeeting();
    this.dtOptions = {
      pagingType: 'full_numbers'
    };
    this.selectedItems = [
      { }
    ];
    this.dropDownForm = this.fb.group({
      courses: [this.selectedItems]
  });
  // Assuming responseData contains the backend response
// Set selectedAction based on activity value

  }
  //Default date time in form
  current_date:any;
  current_time;any;
  setCurrentdate(){
    this.current_date=this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.current_time=this.datepipe.transform(new Date(), 'HH:mm');
    this.createmeetingform.get('activity_date').setValue(this.current_date);
    this.createmeetingform.get('activity_time').setValue(this.current_time);
  }
  public showSpinner(): void {
    this.spinnerService.show();
    }

  
  getdata(){
    this.customers=[];
        for(const prop in this.ApiService.tabledatameeting) {
            this.customers.push(this.ApiService.tabledatameeting[prop])
          }
          this.customers.pop();
    //console.log(this.ApiService.tabledataDA)
    //this.ApiService.viewtableOB();
    

  }

    selectFiles(event:any) {
    console.log(event.target.files[0].name, "dnjsndk");
    if (event.target.files[0].size < 60000) {  
      const formData: FormData = new FormData();
      formData.append('file', event.target.files[0]);
      this.ApiService.uploadActivityFile(formData).subscribe((da: any) => {
        this.uploadFiles = da;
      })
  
    } else {
      alert('The size should be less than 60kb');
      $('#file').val('');
    }
    
  }
  passwordMatchValidator(control: AbstractControl): ValidationErrors | null {
    const password = control.get('password');
    const confirm_password = control.get('confirm_password');

    if (password && confirm_password && password.value !== confirm_password.value) {
      console.log('Passwords do not match');
        return { 'passwordMismatch': true }; // Return error if passwords don't match
    }

    return null; // Return null if passwords match or any control is missing
}


  handleClickNavigate(id: any) {
    this.router.navigate(['activity-summary', id]);
  }

   handleBlurChange() {
    let password = $('#password').val();
    let confirm_password = $('#confirm_password').val();
    if (password !== confirm_password) {
      this.password_wrong = true;
    } else {
      this.password_wrong = false;
    }
  }
  

  postdata(angForm1 : any) //angForm1
  {
    console.log(angForm1, "dsnkjkdsjnd");
        console.log(this.createmeetingform.status,
          angForm1,
          angForm1.value.meeting_name,
          angForm1.value.meeting_date,
        );
    let values = angForm1.value;
    values['image'] = this.uploadFiles;
    console.log(values,"djjs");
       
          this.spinner=true;

    this.ApiService.createMentor(values).subscribe((d:any) => {
      console.log(d,"sdndsbjbdsskbskj"); 
              this.spinnerService.hide();
              setTimeout(function(){
                alert("Mentor has been created successfully!")
                window.location.reload();
                },100)
                 
            //this.router.navigate(['superadmin/Meetings']);
             //angForm1.reset();
            },

            error => {
                console.log(error);
            });
            
         
    }
    // delete_mentor(id: any) {
    //   console.log(id);
    //   Swal.fire({
    //     title: "Are you sure want to delete this Mentor?",
    //     icon: "warning",
    //     showCancelButton: true,
    //     iconColor: "#015792",
    //     confirmButtonColor: "#3085d6",
    //     cancelButtonColor: "#d33",
    //     confirmButtonText: "Yes, delete it!"
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       //console.log("Implement delete functionality here");
    //       this.spinner = true;
    // this.spinnerService.show();
    //       this.ApiService.deleteMentor(id)
    //         .subscribe(
    //           data => {
    //             this.spinner = false;
    //             this.spinnerService.hide();
    //             window.location.reload();
    //           },
    //           error => {
    //             console.log(error);
    //           });
    //       Swal.fire(
    //         "Deleted!",
    //         "Mentor has been deleted.",
    //         "success"

    //       );
    //     }
    //   });
    // }
    // selectedAction: string | null = null; // Variable to store the selected action

    // approve_Mentor(id: any, action: any) {
    //   console.log('Selected Action:', action.target.value);
    //   this.selectedAction = action; // Update the selected action variable
      
    //   this.ApiService.approveMentor(id, action.target.value)
    //     .subscribe(
    //       (data) => {
    //         // Handle the response data here
    //         console.log('Approval successful:', data);
    //       },
    //       (error) => {
    //         // Handle errors here
    //         console.error('Error occurred during approval:', error);
    //       }
    //     );
    // }
//     selectedAction: string = ''; // Initialize selectedAction variable

//     approve_Mentor(id: any, action: any) {
//       console.log('Selected Action:', action.target.value);
//       this.selectedAction = action; // Update the selected action variable
//       this.ApiService.approveMentor(id, action.target.value)
//       .subscribe(
//         (data) => {
//           // Handle the response data here
//           console.log('Approval successful:', data);
//         },
//         (error) => {
//           // Handle errors here
//           console.error('Error occurred during approval:', error);
//         }
//         );
// }

selectedAction: string | null = null; // Variable to store the selected action

approve_Mentor(id: any, event: Event) {
  const selectedValue = (event.target as HTMLSelectElement).value;
  console.log('Selected Action:', selectedValue);
  this.selectedAction = selectedValue; // Update the selected action variable

  this.ApiService.approveMentor(id, selectedValue)
    .subscribe(
      (data) => {
        // Handle the response data here
        console.log('Approval successful:', data);
      },
      (error) => {
        // Handle errors here
        console.error('Error occurred during approval:', error);
      }
    );
}


  radiobutton(option:any){
    this.MeetingOptions=option;
    // console.log(this.MeetingOptions);
  }
 
  Mentor_name: any;
  Mentor_last_name: any;
  Mentor_education: any;
  Mentor_branch: any;
  Mentor_area: any;
  Mentor_courses: any;
  Mentor_meeting_location:any;
  Mentor_date:any;
  Mentor_time: any;
  Mentor_description: any;
  Mentor_activity_type:any;
  Mentor_comments:any;
  Mentor_participants:any;
  Mentor_constituency: any;
  Mentor_assigned_to: any;
  Mentor_status: any;
  Mentor_activity: any;
  Mentor_others: any;
  Mentor_district: any;
  Mentor_father_name: any;
  Mentor_DOB: any;
  Mentor_email: any;
  Mentor_number: any;
  Mentor_parent_number: any;
  Mentor_grade: any;
  Mentor_college_name: any;
  Mentor_subject: any;
  Mentor_image: any;
  

editfield:boolean=false;
  buttonviewmeeting(a:any,editbutton:any ){
   // console.log(a,editbutton,"dsbskdb");
    console.log(a)
    if (editbutton == 'edit') {
      $('#card_title').html('Edit Mentor’s Details');
      this.editfield = true;
    } else {
      $('#card_title').html('Mentor’s Details');
      this.editfield = false;

    }
    this.Mentor_name = a.first_name;
    this.Mentor_last_name = a.last_name;
    this.Mentor_education = a.education;
    this.Mentor_email = a.email;
    this.Mentor_number = a.number;
    this.Mentor_area = a.area;
    this.Mentor_courses = a.courses;
    this.Mentor_district = a.district;
    console.log(' a.district: ',  a.district);
    this.Mentor_activity = a.activity;
    console.log('a.activity: ', a.activity);
    console.log('this.Mentor_activity: ', this.Mentor_activity);

   // this.Mentor_constituency = a.constituency;
    this.Mentor_status = a.status;
    this.Mentor_branch = a.branch;
    this.Mentor_image = a.image; 
    this.uploadFiles = a.image;
    this.Mentor_id = a.id;
          
    this.editformInitialize(false);
    
    this.editmeetingform.get('first_name').setValue(a.first_name);
    this.editmeetingform.get('last_name').setValue(a.last_name);
    this.editmeetingform.get('education').setValue(a.education);
    this.editmeetingform.get('email').setValue(a.email);
    this.editmeetingform.get('number').setValue(a.number);
    this.editmeetingform.get('branch').setValue(a.branch);
    this.editmeetingform.get('district').setValue(a.district);
    this.editmeetingform.get('activity').setValue(a.activity);
    this.editmeetingform.get('area').setValue(a.area);
    this.editmeetingform.get('courses').setValue(a.courses);
    this.editmeetingform.get('status').setValue(a.status);


    //  if (a.district !== null) {
    //   this.Mentor_constituency = a.constituency;
    //   this.Mentor_district = a.district;
    //   console.log(a.district, "dnsdknd");
    //   this.district = a.district;
    //   this.editmeetingform.get('district').setValue(a.district);
    //   this.user_constituency = this.ApiService.all_constituency[a.district];
    //   this.editmeetingform.get('constituency').setValue(a.constituency)
    // }
    }
                 
          
  editformInitialize(a){
    this.editmeetingform= this.fb.group({
      first_name: ['',[Validators.required]],
      last_name:['',Validators.required,],
      education:['',Validators.required],
      branch:['',Validators.required],
      constituency:['',Validators.required],
      email:['',Validators.required],
      number:['',Validators.required],
      area:['',Validators.required],
      courses:['',Validators.required],
      district:['',Validators.required],
      status: ['', Validators.required],
      image: ['', Validators.required],  
      activity: ['', Validators.required],  

  });
  }

  updatedata(updateform, id) {
    console.log(updateform.value, this.Mentor_id, "lmdldk");
    let values = updateform.value;
    values['image'] = this.uploadFiles;
    this.spinner = true;
    this.spinnerService.show();
    this.ApiService.updateMentor(this.Mentor_id, values)
      .subscribe(
        data => {
          console.log(data);
          this.spinnerService.hide();
          Swal.fire({
            title: "Mentor has been updated!",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#015792",
            iconColor: "#015792" // Set the icon color here
          }).then(() => {
            window.location.reload();
          });
        },
        error => {
          console.log(error);
        });
  }
  
//reset form values in createform
  Formreset(){
      this.createmeetingform.reset();
      this.hidden=true;
      this.MeetingOptions='';
      this.participantsptions='';
  }
  handleBackButtonForModal() {
    // Push initial state to history
    history.pushState(null, '', window.location.href);
  
    window.onpopstate = () => {
      const modal = document.querySelector('.modal.show') as HTMLElement;
      if (modal) {
        // Find the close button inside the modal and trigger a click event on it
        const closeButton = modal.querySelector('.close') as HTMLElement;
        if (closeButton) {
          closeButton.click();
        }
  
        // Prevent default back navigation
        history.pushState(null, '', window.location.href);
      } else {
        // Allow back navigation as usual if modal is not open
        this.router.navigate(['previous-page']); // Replace 'previous-page' with the actual route you want to navigate to
      }
    };
  }
  ngOnDestroy(): void {
    // Cleanup event listener to avoid memory leaks
    window.onpopstate = null;
  }

}
